module.exports = __webpack_public_path__ + "img/clock.5d13ba3d.png";